export default __webpack_public_path__ + "static/undraw_contact_us_edited-8848c87453d635f9d95921fb59b4ca79.svg";